export const dynamicFilters = (state = {}, action) => {
  switch (action.type) {
    case 'SET_DYNAMIC_FILTER_OPTIONS': {
      const { filterResults } = action.payload;
      return { ...filterResults };
    }
    default:
      return state;
  }
};
